import { Project, RiskManagementTool, RiskSource, RiskControlTechniques } from './raiseRiskAllMaster';
import { AssignActionPost } from './../../actiontracker/model/actionDetails.model';
import { LocationDetails } from '../../masterscreen/model/admin-master.model';
import { User } from "./../../shared/models/user.model";

export class RiskRequest {
    RiskRequestId: number = 0;
    RaisedBy: number= 0;
    RiskSourceId: number = 0;
    ProjectId: number = 0;
    ProjectName: string='';
    LocationId: number = 0;
    LocationNm: string='';
    ProjectNm: string='';
    RiskTitle: String = '';
    RiskManagementToolId: number = 0;
    RiskIdentifyBy: String = '';
    SelectedRiskControlNames:any[];
    ActivityLeadingToHazard: String = '';
    HazardIdentified: String = '';
    ThreatIdentified: String = '';
    Consequences: String = '';
    PotentialRiskPear: String = 'People';
    PotentialRiskLikelihood: String = 'A';
    PotentialRiskSeverity: number = 1;
    PotentialPeopleRisk: PeopleRisk;
    PotentialAssetsRisk: AssetsRisk;
    PotentialEnvironmentRisk: EnvironmentRisk;
    PotentialReputationRisk: ReputationRisk;
    PotentialNPTRisk: NPTRisk;
    ResidualPeopleRisk: PeopleRisk;
    ResidualAssetsRisk: AssetsRisk;
    ResidualEnvironmentRisk: EnvironmentRisk;
    ResidualReputationRisk: ReputationRisk;
    ResidualNPTRisk: NPTRisk;
    RiskControlTechniquesId: number = 0;
    ControlMeasure: String = '';
    ContengencyPlan: String = '';
    ResidualRiskPear: String = 'People';
    ResidualRiskLikelihood: String = 'A';
    ResidualRiskSeverity: number = 1;
    AssessmentRiskPear: String = 'People';
    AssessmentRiskLikelihood: String = 'A';
    AssessmentRiskSeverity: number = 1;
    RiskMovement: string = '0';
    InActive: Boolean = false;
    UnitId: number;
    UnitName: String = '';
    Status: string;
  PotentialPEARList: any;
  ResidualPEARList: any;
  RiskAssessmentPEARList: any;
  IsDraft:boolean=false;
  RiskId: number = 0;
  ContractId:number;
  RiskIdentifiedBy:number = 0;
  ExactLocation: String = '';
  ApprovalStatus:number = 0;
  ApprovalLevel:number = 0;
  ApprovalMaxLevel:number = 0;
 // SelectedriskControlTechniqueIds: string[] = [];
  RiskIdentifiedByEmployee: User;
  RiskRequestMOC: RiskRequestMOC=new RiskRequestMOC();
  RiskRequestHEMP:RiskRequestHEMP=new RiskRequestHEMP();
  RiskRequestJSA:RiskRequestJSA=new  RiskRequestJSA();
  RiskRequestHAZOP:RiskRequestHAZOP=new  RiskRequestHAZOP();
  RiskRequestHAZID:RiskRequestHAZID=new  RiskRequestHAZID();
  Category: CategoryData=new CategoryData();
  ErrorList: string[]=[];
 // riskControlTechniqueIds: string[] = [];

  //MOC Fields
//   MOCNumber:String = '';
//   MOCDescription:String = '';
//   MOCPurpose:String = '';
//   RiskMovementId:number = 0;

  //JSA Fields
//   JSANumber:String = '';
//   JobTitle: String = '';
//   JSASteps: number = 4;
//   ContractorName:String = '';
//   ContractorDesignation:String = '';
//   ContractorRemark:String = '';
//   ContractorDate: Date = new Date();
//   StaffName:String = '';
//   StaffDesignation:String = '';
//   StaffRemark:String = '';
//   StaffDate: Date = new Date();
  
  //HEMP Fields
//   HEMPNumber:String = '';
//   RiskOwnerParty:String = '';
//   HEMPActivity:String = '';
//   HazardAssociated:String = '';
//   HEMPThreats:String = '';
//   HEMPEvents:String = '';
//   HEMPConsequences:String = '';
//   HEMPMaxRiskArea:number = 0;
//   HEMPPreventiveAction:String = '';
//   MitigativePlan:String = '';
//   HEMPResidualMaxRiskArea:number = 0;
//   ReferencetoStandards:String = '';

}

export class RaiseRisk {
    RiskRequest: RiskRequest;
    ActionDetails: AssignActionPost[];
    PotentialPEARList: PearDetails[];
    ResidualPEARList: PearDetails[];
    RiskAssessmentPEARList: PearDetails[];

}

export class CategoryData
{

    ModuleId: number;
	SourceId: number;
	RuleId: any[] = [];
	LstCategoryRuleGroupedByCategoryId: any[] = [];
	Checked: boolean;
	CategoryName: string;
}

export class ToolDetails
{

    ToolId: number;
	IsActive: boolean;
	ToolName: string;
    PageName: string;
}

export class RiskRequestMOC{

    MOCNumber:String = '';
    MOCDescription:String = '';
    MOCPurpose:String = '';
    RiskMovementId:number = 0;
    MOCTypeId:number = 0;
    MOCChangeCategoryId:number = 0;
    MOCOtherChangeCategory:String = null;
    riskControlTechniqueIds: string[] = [];
    SelectedriskControlTechniqueIds: string[] = [];
    DurationFrom: Date = new Date();
    DurationTo: Date = new Date();
    ExtensionUserID :number = 0;
    ApproveOrReject : number = 0;
    Remarks : String = '';
    ExtensionValidTo: Date =  new Date();
    UserApprovalRemark:String = '';
    UserID :number = 0;
    ExtensionUserIsApproved:number = 0;
    MOCUploadFiles: any[] = [];

}

export class RiskRequestJSA{

  JSANumber:String = '';
  JSATitle: String = '';
  NoOfSteps: number = 1;
  ContractorId:number = 0;
  ContractorName:String = '';
  ContractorDesignation:String = '';
  ContractorApprovalRemark:String = '';
  ContractorIsApproved:number = 0;
  ContractorDate: Date = new Date();
  UserID:number = 0
  StaffName:String = '';
  StaffDesignation:string = '';
  UserApprovalRemark:String = '';
  UserIsApproved : number = 0;
  StaffDate: Date = new Date();
  selectedContractor: User;
  selectedStaff: User;
  AuthorizationType:string = '';
  ApproveOrReject : number = 0;
  Remarks : String = '';
  RiskRequestJSASteps:RiskRequestJSASteps[];
}
export class RiskRequestJSASteps
{
    StepDetails:string='';
    PatentialHazards:string='';
    ControlMeasures:string='';
    ResponsiblePerson: User = new User();

}

export class RiskRequestHEMP{

  HEMPNumber:String = '';
  RiskOwnerPartyId:number = 0;
  Activity:String = '';
  HazardAssociatedWithActivity:String = '';
  RiskThreats:String = '';
  RiskEvents:String = '';
  RiskConsequences:String = '';
  CurrentMaximumRiskAreaId:number = 0;
  PreventiveAction:String = '';
  MitigativePlan:String = '';
  ResidualMaximumRiskAreaId:number = 0;
  ReferenceToStandards:String = '';
  RiskOwnerParty: User;
  riskControlTechniqueIds: string[] = [];
  SelectedriskControlTechniqueIds: string[] = [];
  CurrentMaximumRiskArea:string = '';
  ResidualMaximumRiskArea:string = '';
  RiskRequestPreventiveActions:RiskRequestPreventiveActions[];
  RiskRequestMitigativePlan:RiskRequestMitigativePlan[];
}

export class RiskRequestPreventiveActions
{
    SrNo:number = 1;
    PreventiveAction:string='';
    ShowPreventiveActionErrorMessage: boolean = false;
}

export class RiskRequestMitigativePlan
{
    SrNo:number = 1;
    MitigativePlan:string='';
    ShowMitigativePlanErrorMessage: boolean = false;
}

export class RiskRequestHAZOP{

    HAZOPNumber:String = '';
    NoOfElements:number = 1;
    Reference:String = '';
    RiskRequestId:number;
    RiskRequestHAZOPElement:RiskRequestHAZOPElement[];
}

export class RiskRequestHAZOPElement
{
    ElementNumber : number = 1;
    Description:string='';
    DesignParameters:string='';
    OperatingParameters:string='';
    Remark:string='';
    ShowDescriptionErrorMessage: boolean = false;
    ShowDesignParametersErrorMessage: boolean = false;
    ShowOperatingParametersErrorMessage: boolean = false;
    ShowRemarkErrorMessage: boolean = false;
    RiskRequestHAZOPElementDetails:RiskRequestHAZOPElementDetails[] = [];
    HAZOPElementDetailsList:RiskRequestHAZOPElementDetails[] = [];
}

export class RiskRequestHAZOPElementDetails
{
    RiskRequestElementId : number = 1;
    ElementNumber : number = 1;
    RefNo : string = '';
    Deviation:string='';
    CauseRefNo : string = '';
    Cause:string='';
    Consequences:string='';
    ExistingSafeguard:string='';
    RiskSeverity : number = 0;
    RiskLikelihood : number = 0;
    RiskArea:string='';
    Recommendations:string='';
    ActionOwner: User = new User();
}

export class RiskRequestHAZID{

    HAZIDNumber:String = '';
    NoOfElements:number = 1;
    Reference:String = '';
    RiskRequestId:number;
    RiskRequestHAZIDElement:RiskRequestHAZIDElement[];
}

export class RiskRequestHAZIDElement
{
    ElementNumber : number = 1;
    Description:string='';
    DesignParameters:string='';
    OperatingParameters:string='';
    Remark:string='';
    ShowDescriptionErrorMessage: boolean = false;
    ShowDesignParametersErrorMessage: boolean = false;
    ShowOperatingParametersErrorMessage: boolean = false;
    ShowRemarkErrorMessage: boolean = false;
    RiskRequestHAZIDElementDetails:RiskRequestHAZIDElementDetails[] = [];
    HAZIDElementDetailsList:RiskRequestHAZIDElementDetails[] = [];
}

export class RiskRequestHAZIDElementDetails
{
    RiskRequestElementId : number = 1;
    ElementNumber : number = 1;
    RefNo : string = '';
    IdentifiedHazard:string='';
    Source : string = '';
    AssociatedThreats:string='';
    TopEvents:string='';
    Consequences:string='';
    InitialRiskSeverity : number = 0;
    InitialRiskLikelihood : number = 0;
    InitialRiskArea:string='';
    Safeguard:string='';
    ResidualRiskSeverity : number = 0;
    ResidualRiskLikelihood : number = 0;
    ResidualRiskArea:string='';
    ControlMeasures:string='';
    ActionOwner: User = new User();
}


export class RaiseRiskShowErrorMessages {
    showRiskSourceErrorMessage: boolean = false;
    showProjectNameErrorMessage: boolean = false;
    showLocationErrorMessage: boolean = false;
    showRiskTitleErrorMessage: boolean = false;
    showRiskManagementToolErrorMessage: boolean = false;
    showActivityLeadingToHazardErrorMessage: boolean = false;
    showHazardIdentifiedErrorMessage: boolean = false;
    showThreatIdentifiedErrorMessage: boolean = false;
    showConsequencesErrorMessage: boolean = false;
    showPotentialPearErrorMessage: boolean = false;
    showPotentialConsequencesErrorMessage: boolean = false;
    showPotentialSeverityErrorMessage: boolean = false;
    showControlTechniqueErrorMessage: boolean = false;
    showControlMeasureErrorMessage: boolean = false;
    showContegencyPlanErrorMessage: boolean = false;
    showResidualPearErrorMessage: boolean = false;
    showResidualConsequenceErrorMessage: boolean = false;
    showResidualSeverityErrorMessage: boolean = false;
    showResidualRiskMovementErrorMessage: boolean = false;
}

export class RiskRequestGet {
    RiskTitle: String ="";
    ActivityLeadingToHazard: String= "";
    HazardIdentified: String= "";
    ThreatIdentified: String= "";
    Consequences: String= "";
    PotentialRiskPear: String= "";
    PotentialRiskLikelihood: String= "";
    PotentialRiskSeverity: number= 0;
    RiskControlTechniquesId: number= 0;
    ControlMeasure: String= "";
    ContengencyPlan: String= "";
    ResidualRiskPear: String= "";
    ResidualRiskLikelihood: String= "";
    ResidualRiskSeverity: number= 0;
    LocationDetails: LocationDetails;
    ProjectDetails: Project;
    RiskManagmentTool: RiskManagementTool;
    RiskSource: RiskSource;
    RiskControlTechniques: RiskControlTechniques;
    DisplayId: string= "";
    RiskRequestId: number= 0;
}

export class PeopleRisk {
    PeopleRiskPear: String = 'People';
    PeopleRiskLikelihood: String = '0';
    PeopleRiskSeverity: number = 0;
    PeopleRiskColor: string = '';
    PeopleSelected: boolean = false;
}

export class AssetsRisk {
    AssetsRiskPear: String = 'Assets';
    AssetsRiskLikelihood: String = '0';
    AssetsRiskSeverity: number = 0;
    AssetsRiskColor: string = '';
    AssetsSelected: boolean = false;
}

export class EnvironmentRisk {
    EnvironmentRiskPear: String = 'Environment';
    EnvironmentRiskLikelihood: String = '0';
    EnvironmentRiskSeverity: number = 0;
    EnvironmentRiskColor: string = '';
    EnvironmentSelected: boolean = false;
}

export class ReputationRisk {
    ReputationRiskPear: String = 'Reputation';
    ReputationRiskLikelihood: String = '0';
    ReputationRiskSeverity: number = 0;
    ReputationRiskColor: string = '';
    ReputationSelected: boolean = false;
}

export class NPTRisk {
    NPTRiskPear: String = 'NPT';
    NPTRiskLikelihood: String = '0';
    NPTRiskSeverity: number = 0;
    NPTRiskColor: string = '';
    NPTSelected: boolean = false;
}

export class PearDetails {
    RiskPear: String = '';
    RiskLikelihood: String = '0';
    RiskSeverity: number = 0;
    // RiskColor: string = '';
    // RiskSelected: boolean = true;
}
